import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"icon-search\"><defs><style>#icon-search .a{fill:none;}#icon-search .b{fill:#333;stroke:#333;stroke-width:0.4px;}</style></defs><g transform=\"translate(-329 -51)\"><rect class=\"a\" width=\"25\" height=\"25\" transform=\"translate(329 51)\" /><path class=\"b\" d=\"M20.727,13.783l-2.176-2.176a7.014,7.014,0,0,0,1.814-4.625A7.044,7.044,0,0,0,13.382,0,6.966,6.966,0,0,0,6.4,6.891a6.888,6.888,0,0,0,6.891,6.891,6.714,6.714,0,0,0,4.352-1.542l2.267,2.267.816-.725ZM7.488,6.891a5.8,5.8,0,1,1,11.607,0,5.844,5.844,0,0,1-5.8,5.8,5.729,5.729,0,0,1-5.8-5.8Z\" transform=\"translate(327.937 56.086)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/search.svg
// module id = 0R99
// module chunks = 65